import React from 'react';
import { StatusBadge, StatusType } from './StatusBadge';
import { ObjectIdPill } from './ObjectIdPill';
import { ServerIcon, DatabaseIcon, WebhookIcon, CreditCardIcon, BoxIcon } from 'lucide-react';
export interface InfraItem {
  label: string;
  value: string;
  status: StatusType;
  stripeId?: string;
  type: 'server' | 'database' | 'webhook' | 'payment' | 'module';
}
interface InfraPanelProps {
  items: InfraItem[];
  className?: string;
}
const ICON_MAP = {
  server: ServerIcon,
  database: DatabaseIcon,
  webhook: WebhookIcon,
  payment: CreditCardIcon,
  module: BoxIcon
};
export function InfraPanel({
  items,
  className = ''
}: InfraPanelProps) {
  return <div className={`bg-card border border-border rounded-xl shadow-sm overflow-hidden ${className}`} data-id="element-156">
      <div className="px-6 py-4 border-b border-border bg-muted/30 flex justify-between items-center" data-id="element-157">
        <h3 className="font-bold text-sm uppercase tracking-wider text-muted-foreground" data-id="element-158">
          Provisioned Infrastructure
        </h3>
        <StatusBadge status="success" label="All Systems Operational" data-id="element-159" />
      </div>
      <div className="divide-y divide-border" data-id="element-160">
        {items.map((item, i) => {
        const Icon = ICON_MAP[item.type];
        return <div key={i} className="p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:bg-muted/10 transition-colors" data-id="element-161">
              <div className="flex items-center gap-3" data-id="element-162">
                <div className="p-2 bg-primary/10 text-primary rounded-md" data-id="element-163">
                  <Icon className="w-4 h-4" data-id="element-164" />
                </div>
                <div data-id="element-165">
                  <div className="text-sm font-medium" data-id="element-166">{item.label}</div>
                  <div className="text-xs text-muted-foreground" data-id="element-167">
                    {item.value}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-4 sm:justify-end" data-id="element-168">
                {item.stripeId && <ObjectIdPill id={item.stripeId} data-id="element-169" />}
                <StatusBadge status={item.status} data-id="element-170" />
              </div>
            </div>;
      })}
      </div>
    </div>;
}